var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-danger btn-sm",attrs:{"type":"button"},on:{"click":function($event){return _vm.params.context.componentParent.removeItem(_vm.params.data)}}},[_vm._v(" Remove ")])}
var staticRenderFns = []

export { render, staticRenderFns }